module.exports = __webpack_public_path__ + "img/20190906154809558.dc878067.jpg";